import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Chip, Divider, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Chart from "react-apexcharts";
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import BalanceRoundedIcon from '@mui/icons-material/BalanceRounded';
import * as XLSX from 'xlsx';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

const PieGuy = ({
  forecast,
  cash,
  ecash,
  head
}) => {

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });
  
  const config = {
    options: {
      title: {
        text: head,
        align: 'left',
        style: {
          color: '#444',
          fontFamily: "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        }
      },
      labels: ['Forecast Cash Amount', 'Actual Cash Amount', 'Ecash Amount'],
      dataLabels: {
        formatter: function (value) {
          return currencyFormat.format(value);
        }
      },
    },
    series: [forecast, cash, ecash],
    responsive: [{
      breakpoint: 880,
      options: {
        legend: {
          position: 'bottom'
        }
      }
    }]
    
  };

return <Chart 
        options={config.options}
        series={config.series}
        type="pie"
        height={550}
        width={550}
      />
}

const LineCharter = ({ data, typee, head }) => {

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  const config = {
    series: [
      {
        name: "Forecast Cash Data",
        data: data && data.map((item) => item.forecast_cash_value),
      },
      {
        name: "Actual Cash Data",
        data: data && data.map((item) => item.actual_cash_value),
      },
      {
        name: "E-cash Data",
        data: data && data.map((item) => item.momo_value),
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "date",
        categories: data && data.map((item) => formatDateToYearMonthDay(new Date(item.date))),
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return currencyFormat.format(value)
          },
        },
      },
      title: {
        text: head,
        style: {
          color: "#444",
          fontFamily:
            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        },
      },
    },
  };



  return data && (
    <Chart
      options={config.options}
      series={config.series}
      type={typee}
      height={360}
    />
  );
};

const CashFlowReports = ({ society_id, name }) => {
  const [data, setData] = useState([]);
  const [periodic_state, setPeriodicState] = useState("Weekly");
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [clusters, setClusters] = useState([])
  const [selected_cluster, setSelected_cluster] = useState({})
  const [who, setWho] = useState((typeof name === 'string' && name.includes('Society' || 'society')) ? name : `${name} Society`)
  const [communities, setCommunities] = useState([])
  const [selected_com, setSelected_com] = useState({})
  const [groups, setGroups] = useState([])
  const [selected_group, setSelected_group] = useState({})


  const fetch_groups= () => {
    const storedGroups = localStorage.getItem(`groups_${selected_com?.id}`);
    
    if (storedGroups) {
      setGroups(JSON.parse(storedGroups));
    } else {
      api
      .get(`/association/get/groups/in/communities/${selected_com?.id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setGroups(response.data?.groups);
        localStorage.setItem(`groups_${selected_com?.id}`, JSON.stringify(response.data?.groups));
      })
      .catch(function (error) {
        console.log(error);
      });
    }
    
  };

  useEffect(() => {
    if(selected_com?.id){
      fetch_groups();
    }
  }, [selected_com])


  const fetch_communities= () => {
    const storedComm = localStorage.getItem(`communitiess_${selected_cluster?.id}`);
    
    if (storedComm) {
      setCommunities(JSON.parse(storedComm));
    } else {
      api
      .get(`/association/get/communities/in/cluster/${selected_cluster?.id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCommunities(response.data?.communities);
        localStorage.setItem(`communitiess_${selected_cluster?.id}`, JSON.stringify(response.data?.communities));
      })
      .catch(function (error) {
        console.log(error);
      });
    }
    
  };

  useEffect(() => {
    if(selected_cluster?.id){
      fetch_communities();
    }
  }, [selected_cluster])
  

  const fetch_clusters = () => {
    const storedClusters = localStorage.getItem(`clusters_${society_id}`);
    
    if (storedClusters) {
      setClusters(JSON.parse(storedClusters));
    } else {
      api
        .get(`/association/get/clusters/${society_id}`, {
          headers: {
            Authorization: 'Bearer ' + fetchToken(),
          },
        })
        .then(function (response) {
          setClusters(response.data?.all);
          localStorage.setItem(`clusters_${society_id}`, JSON.stringify(response.data?.all));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  useEffect(()=>{
    fetch_clusters()
  },[society_id])


  const fetch_data = () => {
    const cacheKey = `fetch_data_${society_id}_${periodic_state}_${start_date}_${end_date}_${selected_cluster?.id}_${selected_com?.id}_${selected_group?.id}`;
  
    const cachedData = localStorage.getItem(cacheKey);
  
    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      setData(parsedData);
    } else {
      const data = new FormData();
      data.append("society_id", society_id);
      data.append("periodic_state", periodic_state);
      data.append("start_date", start_date);
      data.append("end_date", end_date);
      data.append("cluster_id", selected_cluster?.id ? selected_cluster.id : 0);
      data.append("community_id", selected_com?.id ? selected_com.id : 0);
      data.append("group_id", selected_group?.id ? selected_group.id : 0);
  
      api
        .post("/association/get/society/actual/and/forecast/data", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          localStorage.setItem(cacheKey, JSON.stringify(response.data));
          setData(response.data);
          // console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    fetch_data();
  }, [periodic_state, start_date, end_date, selected_cluster, selected_com, selected_group]);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }


  const exportToExcel = () => {
    const title =  `${who} ${periodic_state} Report (GHS)`; 
    const headers = [
      "Date", "Forecast Cash Amount", "Actual Cash Amount", "E-cash Amount"
    ];
  
    // Prepare data with header rows
    const datta = data && data?.all_data?.filter(row =>
      row.date !== 0 ||
      row.forecast_cash_value !== 0 ||
      row.actual_cash_value !== 0 ||
      row.momo_value !== 0
    ).map(row => [
      formatDateToYearMonthDay(new Date(row.date)),
      row.forecast_cash_value,
      row.actual_cash_value,
      row.momo_value
    ]);
  
    // Combine title, headers, and data into worksheet
    const worksheetData = [[title], [], headers, ...datta];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    
    // Merge title row cells
    XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: "A1" });
    worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
    
    // Style title row (optional)
    worksheet["A1"].s = {
      font: { bold: true, sz: 16 },
      alignment: { vertical: "center", horizontal: "center" },
    };
  
    // Create workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
    // Export to Excel
    XLSX.writeFile(workbook, "CashFlow.xlsx");
  };



  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <Item>
          <Box>
            <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Filters</b>
            </Typography>
            <Divider sx={{ my:1 }}/>
            <Box sx={{ display:'flex', flexDirection:'row', my:1 }}>
              <Typography sx={{ mr:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>From</b>
              </Typography>
                <TextField
                  type="date"
                  size="small"
                  required
                  variant="outlined"
                  name="start_date"
                  onChange={(e) => setStart_date(e.target.value)}
                  value={start_date}
                  sx={{ mr: 1 }}
                />
            </Box>
            <Box sx={{ display:'flex', flexDirection:'row', my:1 }}>
              <Typography sx={{ mr:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>To</b>
              </Typography>
              <TextField
                type="date"
                size="small"
                required
                variant="outlined"
                name="end_date"
                onChange={(e) => setEnd_date(e.target.value)}
                value={end_date}
                sx={{ mr: 1 }}
              />
            </Box>
            
            <Box sx={{ display:'flex', flexDirection:'row', my:1 }}>
              <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Date: {start_date?formatDateToYearMonthDay(new Date(start_date)): 'Default'}{'  '} - {'  '} {end_date?formatDateToYearMonthDay(new Date(end_date)): 'Default'}</b>
              </Typography>
            </Box>
                <Divider variant='middle' />
            <Box sx={{ display:'flex', flexDirection:'row', my:1 }}>
              <Typography variant='h6' sx={{ color:'#344e41' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Cluster: {selected_cluster?.cluster? selected_cluster?.cluster : 'Not Filtered'}</b>
              </Typography>
            </Box>
              <Divider variant='middle' />
            <Box sx={{ display:'flex', flexDirection:'row', my:1 }}>
              <Typography variant='h6' sx={{ color:'#432818' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Community: {selected_com?.community? selected_com?.community : 'Not Filtered'}</b>
              </Typography>
            </Box>
              <Divider variant='middle' />
            <Box sx={{ display:'flex', flexDirection:'row', my:1 }}>
              <Typography variant='h6' sx={{ color:'#432818' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Savings Group: {selected_group?.group? selected_group?.group : 'Not Filtered'}</b>
              </Typography>
            </Box>
          </Box>
        </Item>
      </Grid>
      <Grid item xs={12} md={12}>
        <Item>
          <Divider>
            <Typography fontStyle='italic' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Clusters {selected_cluster?.id && <Chip 
                                          size='small'
                                          label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Clear</b></Typography>}
                                          sx={{
                                            borderRadius:2,
                                            m:1,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            backgroundColor:'#da1e37',
                                            color:'#fff',
                                            '&:hover': {
                                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                              backgroundColor:'#14213d',
                                            },
                                          }} 
                                          onClick={() => {
                                            setSelected_cluster({})
                                            setSelected_com({})
                                            setSelected_group({})
                                          }} 
                                        />}</b>
            </Typography>
          </Divider>
          <Box
            sx={{
              overflowX: "auto",
              maxWidth: '100%',
              display:'flex',
              flexDirection: 'row',
              "&::-webkit-scrollbar": {
                height: "7px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
            }}
          >
            {
              clusters.map((cluster) => (
                <Chip
                  label={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>{cluster.cluster_name}</b>
                    </Typography>
                  }
                  size="small"
                  variant={selected_cluster?.id && selected_cluster?.id === cluster.cluster_id ? "filled" : "outlined"}
                  sx={{
                    m: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor:
                    selected_cluster?.id && selected_cluster?.id === cluster.cluster_id ? "#fff" : "#344e41",
                    color: selected_cluster?.id && selected_cluster?.id === cluster.cluster_id ? "#000" : "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                      color: "#000",
                    },
                  }}
                  onClick={() => {
                    setSelected_cluster({'id': cluster.cluster_id, 'cluster': cluster.cluster_name})
                    setWho(cluster.cluster_name)
                  }}
                />
              ))
            }
          </Box>
          <Divider>
            <Typography fontStyle='italic' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>{selected_cluster?.cluster && selected_cluster?.cluster} Communities {selected_com?.id && <Chip 
                                          size='small'
                                          label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Clear</b></Typography>}
                                          sx={{
                                            borderRadius:2,
                                            m:1,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            backgroundColor:'#da1e37',
                                            color:'#fff',
                                            '&:hover': {
                                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                              backgroundColor:'#14213d',
                                            },
                                          }} 
                                          onClick={() => {
                                            setSelected_com({})
                                            setSelected_group({})
                                          }} 
                                        />}</b>
            </Typography>
          </Divider>

          <Box
            sx={{
              overflowX: "auto",
              maxWidth: '100%',
              display:'flex',
              flexDirection: 'row',
              "&::-webkit-scrollbar": {
                height: "7px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
            }}
          >
            {
              !selected_cluster?.id?
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>No Cluster Selected</b>
                </Typography>
                :
                communities.map((community) => (
                  <Chip
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{community.community_name}</b>
                      </Typography>
                    }
                    size="small"
                    variant={selected_com?.id && selected_com?.id === community.community_id ? "filled" : "outlined"}
                    sx={{
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor:
                      selected_com?.id && selected_com?.id === community.community_id ? "#fff" : "#432818",
                      color: selected_com?.id && selected_com?.id === community.community_id ? "#000" : "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#000",
                      },
                    }}
                    onClick={() => {
                      setSelected_com({'id': community.community_id, 'community': community.community_name})
                      setWho(community.community_name)
                    }}
                  />
                ))
            }
          </Box>

          <Divider>
            <Typography fontStyle='italic' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>{selected_group?.group && selected_group?.group} Saving Groups {selected_group?.id && <Chip 
                                          size='small'
                                          label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Clear</b></Typography>}
                                          sx={{
                                            borderRadius:2,
                                            m:1,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            backgroundColor:'#da1e37',
                                            color:'#fff',
                                            '&:hover': {
                                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                              backgroundColor:'#14213d',
                                            },
                                          }} 
                                          onClick={() => setSelected_group({})} 
                                        />}</b>
            </Typography>
          </Divider>

          <Box
            sx={{
              overflowX: "auto",
              maxWidth: '100%',
              display:'flex',
              flexDirection: 'row',
              "&::-webkit-scrollbar": {
                height: "7px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
            }}
          >
            {
              !selected_com?.id?
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>No Community Selected</b>
                </Typography>
                :
                groups.map((group) => (
                  <Chip
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{group.association_name}</b>
                      </Typography>
                    }
                    size="small"
                    variant={selected_group?.id && selected_group?.id === group.association_id ? "filled" : "outlined"}
                    sx={{
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor:
                      selected_group?.id && selected_group?.id ===group.association_id ? "#fff" : "#432818",
                      color: selected_group?.id && selected_group?.id ===group.association_id ? "#000" : "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#000",
                      },
                    }}
                    onClick={() => {
                      setSelected_group({'id':group.association_id, 'group': group.association_name})
                      setWho(group.association_name)
                    }}
                  />
                ))
            }
          </Box>
          
          <Box sx={{ my: 3 }}>
            <Typography
              sx={{ textAlign: "center" }}
              variant="h5"
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>{who} {periodic_state} Report <Chip 
                                          size='small'
                                          label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Export Table</b></Typography>}
                                          sx={{
                                            borderRadius:2,
                                            m:1,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            backgroundColor:'#fff9ec',
                                            color:'#000',
                                            '&:hover': {
                                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                              backgroundColor:'darkblue',
                                              color:'#fff'
                                            },
                                          }} 
                                          onClick={exportToExcel} 
                                        /></b>
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Chip
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Weekly Report</b>
                </Typography>
              }
              size="medium"
              variant={periodic_state === "Weekly" ? "filled" : "outlined"}
              sx={{
                m: 1,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                backgroundColor:
                  periodic_state === "Weekly" ? "#fff" : "#2b2d42",
                color: periodic_state === "Weekly" ? "#000" : "#fff",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                  color: "#000",
                },
              }}
              onClick={() => setPeriodicState("Weekly")}
            />
            <Chip
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Monthly Report</b>
                </Typography>
              }
              size="medium"
              variant={periodic_state === "Monthly" ? "filled" : "outlined"}
              sx={{
                m: 1,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                backgroundColor:
                  periodic_state === "Monthly" ? "#fff" : "#2b2d42",
                color: periodic_state === "Monthly" ? "#000" : "#fff",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                  color: "#000",
                },
              }}
              onClick={() => setPeriodicState("Monthly")}
            />
            <Chip
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Quarterly Report</b>
                </Typography>
              }
              size="medium"
              variant={periodic_state === "Quarterly" ? "filled" : "outlined"}
              sx={{
                m: 1,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                backgroundColor:
                  periodic_state === "Quarterly" ? "#fff" : "#2b2d42",
                color: periodic_state === "Quarterly" ? "#000" : "#fff",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                  color: "#000",
                },
              }}
              onClick={() => setPeriodicState("Quarterly")}
            />
            <Chip
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Yearly Report</b>
                </Typography>
              }
              size="medium"
              variant={periodic_state === "Yearly" ? "filled" : "outlined"}
              sx={{
                m: 1,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                backgroundColor:
                  periodic_state === "Yearly" ? "#fff" : "#2b2d42",
                color: periodic_state === "Yearly" ? "#000" : "#fff",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                  color: "#000",
                },
              }}
              onClick={() => setPeriodicState("Yearly")}
            />
          </Box>
          <Box
            sx={{
              overflowX: "auto",
              maxHeight: 340,
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                width: "7px",
                height: "7px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
            }}
          >
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Date</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Forecast Cash Deposits (T: {currencyFormat.format(data?.all_data?.reduce((acc, one) => acc + Number(one.forecast_cash_value), 0))})</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Actual Cash Deposits (T: {currencyFormat.format(data?.society_cash_value)})</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>E-cash Deposits (T: {currencyFormat.format(data?.society_momo_value)})</b>
                    </Typography>{" "}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.all_data
                  ?.filter(
                    (row) =>
                      row.forecast_cash_value !== 0 ||
                      row.actual_cash_value !== 0 ||
                      row.momo_value !== 0
                  )
                  .reverse()
                  .map((row, index) => (
                    <TableRow
                      key={row.index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        backgroundColor: "#f5f3f4",
                      }}
                    >
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{formatDateToYearMonthDay(new Date(row.date))} - {formatDateToYearMonthDay(new Date(row.ed_date))}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>
                            {currencyFormat.format(row.forecast_cash_value)}
                          </b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          
                          <Box display="flex" alignItems="center">
                            <b>{currencyFormat.format(row.actual_cash_value)}</b>
                            <span style={{ marginLeft: "8px" }}>
                              {row.actual_cash_value > row.forecast_cash_value ? (
                                <ArrowUpwardRoundedIcon sx={{ color: "#007200" }} />
                              ) : row.actual_cash_value < row.forecast_cash_value ? (
                                <ArrowDownwardRoundedIcon sx={{ color: "#ff0000" }} />
                              ) : (
                                <BalanceRoundedIcon sx={{ color: "#03045e" }} />
                              )}
                            </span>
                          </Box>
                            {row.actual_cash_value > row.forecast_cash_value && (
                              <Box sx={{ color: "#007200" }}>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="caption" fontSize="0.8em">
                                  <b>
                                    {currencyFormat.format(row.actual_cash_value - row.forecast_cash_value)}{" "}
                                    (Above Forecast)
                                  </b>
                                </Typography>
                              </Box>
                            )}
                            {row.actual_cash_value < row.forecast_cash_value && (
                              <Box sx={{ color: "#ff0000" }}>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="caption" fontSize="0.8em">
                                  <b>
                                    {currencyFormat.format(row.forecast_cash_value - row.actual_cash_value)}{" "}
                                    (Below Forecast)
                                  </b>
                                </Typography>
                              </Box>
                            )}
                            {row.actual_cash_value === row.forecast_cash_value && (
                              <Box sx={{ color: "#03045e" }}>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="caption" fontSize="0.8em">
                                  <b>(Matches Forecast)</b>
                                </Typography>
                              </Box>
                            )}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{currencyFormat.format(row.momo_value)}</b>
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Box>
        </Item>
      </Grid>
      
      {/* charts */}
      <Grid item xs={12} md={12} sx={{ mb: 5 }}>
        <Item>
          <LineCharter data={data?.all_data} typee="area" head={`${who} ${periodic_state} Report`}/>
        </Item>
      </Grid>
      <Grid item xs={12} md={6} sx={{ mb: 5 }}>
        <Item>
          <LineCharter data={data?.all_data} typee="bar"  head={`${who} ${periodic_state} Report`}/>
        </Item>
      </Grid>
      <Grid item xs={12} md={6} sx={{ mb: 5 }}>
        <Item>
          <PieGuy forecast={data?.all_data?.reduce((acc, one) => acc + Number(one.forecast_cash_value), 0)} cash={data?.society_cash_value} ecash={data?.society_momo_value} head={`${who} ${periodic_state} Report`} />
        </Item>
      </Grid>
    </Grid>
  );
};

export default CashFlowReports;
